<template>
  <div class="text-center">
    <v-dialog v-model="Cloader.showing" persistent>
      <v-overlay>
        <v-progress-circular
          :size="70"
          :width="7"
          :color="colors[color_index]"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "CLoader",
  data() {
    return {
      colors: ["cleed_blue", "#fafafa", "primary"],
      color_index: 0,
    };
  },
  computed: {
    Cloader() {
      return this.$store.state.Cloader;
    },
  },
  created() {
    setInterval(() => {
      if (this.color_index === 0) this.color_index = 1;
      else if (this.color_index === 1) this.color_index = 2;
      else if (this.color_index === 2) this.color_index = 0;
    }, 1000);
  },
};
</script>

<style scoped>
.overlay {
  opacity: 0.46;
  background-color: rgb(33 33 33 / 0%);
  border-color: rgb(33 33 33);
}
</style>
